import React, { useRef, useState } from 'react';
import { Link, Link as RouterLink } from 'react-router-dom';
import { Stack, MenuItem, IconButton, Badge } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import MenuPopover from './MenuPopover';
import AccountHeader from './accountHeader';
// import NotificationPopover from '../components/NotificationPopover';
import { ORGANIZATION_TYPE } from '../../config/constants';
import { PERM_STORE_SETTINGS } from '../../config/permissions';
import { _can, _route } from '../../utils';
import notificationIcon from '../../assets/images/notificationiconAisle.svg';
import { isVendorAccount } from '../../utils/featureCheck';

const useStyles = makeStyles(() => ({
  menuItem: {
    fontSize: '14px!important',
    fontWeight: '500!important',
    padding: '10px 14px!important',
    fontFamily: '"Inter", "Roboto", sans-serif !important',
  },
}));

const getMenuOptions = (product, orgType, realm, onboarding, spConnected) => {
  const menus = [
    {
      label: 'My Profile',
      icon: 'eva:home-fill',
      linkTo: _route('account.profile', { realm }),
    },
    ...(onboarding
      ? [
          {
            label: 'Store Settings',
            icon: 'eva:home-fill',
            linkTo: _route('store.profile', { realm }),
            permission: PERM_STORE_SETTINGS,
          },
        ]
      : []),
  ];
  switch (String(product)) {
    case 'growz':
    case 'aisle':
      return [
        ...menus,
        ...(onboarding && orgType === ORGANIZATION_TYPE.BRAND
          ? [
              {
                label: 'Subscription Details',
                icon: 'eva:home-fill',
                linkTo: _route('subscription.activePlan', { realm }),
              },
            ]
          : []),
        ...(!isVendorAccount() && spConnected
          ? [
              {
                label: 'Account Health',
                icon: 'eva:settings-2-fill',
                linkTo: _route('account.health.account'),
              },
            ]
          : []),
        {
          label: 'Help Center',
          icon: 'eva:settings-2-fill',
          linkTo: 'https://support.sellergeni.com/',
        },
      ];
    default:
      return [
        {
          label: 'My Profile',
          icon: 'eva:home-fill',
          linkTo: _route('account.profile', { realm }),
        },
        {
          label: 'Help Center',
          icon: 'eva:settings-2-fill',
          linkTo: 'https://support.sellergeni.com/',
        },
      ];
  }
};

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const classes = useStyles();
  const { realm, org, store } = useSelector(({ auth }) => auth);
  const allNotifications = useSelector(({ page }) => page.allNotifications?.data || []);
  const { amazonSPConnected } = store;

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
  const menus = getMenuOptions(realm, org.type, realm, store.profile && store.onboardingDone, amazonSPConnected).filter(
    (i) => !i.permission || (i.permission && _can(i.permission)),
  );

  let highPriority = 0;

  if (allNotifications) {
    highPriority = allNotifications?.filter((item) => item?.priority === 'High')?.length;
  }

  return (
    <>
      {/* <NotificationPopover /> */}

      {realm !== 'stores' && (
        <IconButton
          ref={anchorRef}
          color={'default'}
          className={'defaultsvg'}
          sx={{ width: 36, height: 36, marginRight: '1em' }}
        >
          <Link to={_route('alerts', { realm })}>
            <Badge badgeContent={highPriority} color="error">
              <img src={notificationIcon} />
            </Badge>
          </Link>
        </IconButton>
      )}

      <IconButton
        ref={anchorRef}
        className="accountHover"
        sx={{
          p: 0,
          borderRadius: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
            },
          }),
        }}
      >
        <div
          onClick={handleOpen}
          style={{
            // backgroundColor: 'black',
            padding: '5%',
            display: 'flex',
            alignItems: 'center',
            fontFamily: '"Inter", Roboto, sans-serif !important',
          }}
        >
          <AccountHeader />
        </div>
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          borderRadius: '12px',
          border: '1px solid #F2F4F7',
          boxShadow:
            '0px 5px 5px -3px rgb(145 158 171 / 20%), 0px 8px 10px 1px rgb(145 158 171 / 14%), 0px 3px 14px 2px rgb(145 158 171 / 12%)',
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Stack sx={{ p: 1 }}>
          {menus.map((option) => {
            if (option.linkTo.indexOf('http') === 0) {
              return (
                <a
                  key={option.label}
                  href={option.linkTo}
                  style={{ color: '#000' }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <MenuItem className={classes.menuItem} onClick={handleClose}>
                    {option.label}
                  </MenuItem>
                </a>
              );
            }
            return (
              <MenuItem
                className={classes.menuItem}
                key={option.label}
                to={option.linkTo}
                component={RouterLink}
                onClick={handleClose}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </Stack>

        <div className="dashedDivider" />

        <Link
          to={_route('logout')}
          onClick={handleClose}
          style={{ margin: '10px 10px', color: 'initial', display: 'block' }}
          className={classes.menuItem}
        >
          Logout
        </Link>
      </MenuPopover>
    </>
  );
}
